import { parse } from 'libphonenumber-js';

// Takes a formatted phone number -- such as "(973) 601-8200" --
// and parses it into an unformatted string to store in the redux store -- such as "9736018200"
const parsePhone = country => value => {
	const parsedValue = parse(value, country);
	return parsedValue.phone ? parsedValue.phone : value;
};

export default parsePhone;
